import React, { useEffect, useRef, useState } from "react";
// nodejs library that concatenates classes
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import "../../assets/scss/App.scss";
import styles from "../../components/components.js";
import InputMask from "react-input-mask";
import notifyMe from "./styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import FormLabel from "@material-ui/core/FormLabel";
import { GenerateEncryptedToken } from "../../views/Common";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Chip from "@material-ui/core/Chip";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { withStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import smartParkService from "../../axios";
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const useStyles = makeStyles(styles);
const usenotifyMe = makeStyles(notifyMe);
const ModalDialog = withStyles((theme) => ({
  root: {
    "& .MuiDialog-paper": {
      padding: "1px",
      maxHeight: "90vh",
    },
  },
}))(Dialog);
export default function NotifyMe({
  modalStatus,
  closeModalHandler,
  parkArray,
}) {
  const classes = useStyles();
  const notify = usenotifyMe();
  const inputRef = useRef(null);
  const [inputFields, setInputFields] = useState({
    mobile: {
      value: "",
      error: "",
    },
    email: {
      value: "",
      error: "",
    },
  });
  const [globalError, setGlobalError] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState("sm");
  const [facilitiesList, setFacilitiesList] = useState({});
  const [fetchedUserDetails, setfetchedUserDetails] = useState({
    UserNotifyID: null,
    MobilePhone: null,
    Email: null,
    Fieldssubscribed: [],
  });
  const [userDetailsFetchField, setUserDetailsFetchField] = useState("");
  const [fetchedSecondaryFieldValue, setFetchedSecondaryFieldValue] =
    useState("");
  const [otpField, setOtpField] = useState({
    show: false,
    error: "",
    fieldValue: null,
    fieldLabel: "",
  });
  const [formState, setFormState] = useState("submit");
  const [blockInputField, setBlockInputField] = useState(false);
  const [consentField, setConsentField] = useState({
    name: "mobileNotificationConsentField",
    show: false,
    value: "",
    errorMessage: "",
    label:
      "I consent to receive an activation code and notifications on my mobile number.",
  });

  const renderToasts = ({ message, type }) => {
    toast(message, {
      position: toast.POSITION.TOP_CENTER,
      transition: Bounce,
    });
  };
  const closeModal = () => {
    closeModalHandler();
    //reset user details
    setFormState("submit");
    setUserDetailsFetchField("");
    setFetchedSecondaryFieldValue("");
    setGlobalError("");
    setBlockInputField(false);
    setfetchedUserDetails({
      UserNotifyID: null,
      MobilePhone: null,
      Email: null,
      Fieldssubscribed: [],
    });
    setConsentField({
      ...consentField,
      show: false,
      errorMessage: "",
      value: false,
    });

    //reset input fields
    setInputFields({
      mobile: {
        value: "",
        error: "",
      },
      email: {
        value: "",
        error: "",
      },
    });

    //reset otp field
    setOtpField({
      show: false,
      error: "",
      fieldValue: null,
      fieldLabel: "",
    });
  };

  const consentBoxHandler = (e) => {
    if (blockInputField) {
      displayGlobalError("Fields can't be updated during form submission.");
      return;
    }
    setConsentField({
      ...consentField,
      value: e.target.checked,
      errorMessage: "",
    });
  };
  const otpInputHandler = (e) => {
    const inputValue = e.target.value.substring(0, 6);
    setOtpField({
      ...otpField,
      fieldValue: inputValue,
    });
  };
  const displayGlobalError = (errorMessage) => {
    // console.log("global errror called");
    setGlobalError(errorMessage);
    setTimeout(() => {
      setGlobalError("");
    }, 3000);
  };
  const hideOtpField = () => {
    setOtpField({
      ...otpField,
      show: false,
    });
  };
  const removeField = ({ index, id, fieldName, park }) => {
    if (blockInputField) {
      displayGlobalError(
        "Field can't be removed while form submission is in process. "
      );
      return;
    }
    setfetchedUserDetails((prevDetails) => ({
      ...prevDetails,
      Fieldssubscribed: prevDetails.Fieldssubscribed.map((subscription) => {
        console.log("subs", subscription);
        if (
          subscription.fields.length > 1 &&
          subscription.fieldNames.length > 1
        ) {
          return {
            type: subscription.type,
            fields: subscription.fields.filter((name) => name !== id),
            fieldNames: subscription.fieldNames.filter(
              (name) => name !== fieldName
            ),
          };
        } else if (
          subscription.fields.length === 1 &&
          subscription.fieldNames.length === 1
        ) {
          return {
            type: subscription.type,
            fields: subscription.fields.filter((name) => name !== id),
            fieldNames: subscription.fieldNames.filter(
              (name) => name !== fieldName
            ),
          };
        }
        return subscription;
      }),
    }));
    if (park.fields.length === 1 && park.fieldNames.length === 1) {
      removePark({ field: park });
    }
  };
  const removePark = ({ field }) => {
    if (blockInputField) {
      displayGlobalError(
        "Park can't be removed while form submission is in process."
      );
      return;
    }
    setfetchedUserDetails((prevDetails) => ({
      ...prevDetails,
      Fieldssubscribed: prevDetails.Fieldssubscribed.filter(
        (subscriptions) => subscriptions.type !== field.type
      ),
    }));
  };
  const setFieldValue = ({ fieldName, fieldValue }) => {
    setInputFields((prevInputFields) => ({
      ...prevInputFields,
      [fieldName]: {
        ...prevInputFields[fieldName],
        value: fieldValue,
      },
    }));
  };
  const inputHandler = ({ name, value }) => {
    // console.log(userDetailsFetchField, name, value.target.value);
    if (blockInputField) {
      setErrors({
        name: name,
        errorMessage:
          "Input Fields cannot be modified while form submission is in process.",
      });
      setTimeout(() => {
        setErrors({
          name: name,
          errorMessage: "",
        });
      }, 3000);
      return;
    }
    //remove all previus errors for the input field
    setErrors({ name: name, errorMessage: "" });
    let inputValue = value.target.value;

    //remove user fetched details once input field is cleared after fetching details
    if (
      userDetailsFetchField &&
      userDetailsFetchField === name &&
      (inputValue?.replace(/-/g, "") === "" || inputValue === "")
    ) {
      setUserDetailsFetchField("");
      setfetchedUserDetails({
        UserNotifyID: null,
        MobilePhone: null,
        Email: null,
        Fieldssubscribed: [],
      });
      setInputFields({
        mobile: {
          value: "",
          error: "",
        },
        email: {
          value: "",
          error: "",
        },
      });
      setConsentField({
        ...consentField,
        show: false,
        value: false,
      });

      // console.log("value is empty");
    }

    if (name === "mobile") {
      //remove '-' from the input value
      let formattedResult = inputValue.replace(/-/g, "");
      if (
        userDetailsFetchField === "email" &&
        formattedResult.trim().length > 0
      ) {
        setConsentField({ ...consentField, show: true, value: false });
      } else if (
        userDetailsFetchField === "email" &&
        formattedResult.trim().length === 0
      ) {
        setConsentField({ ...consentField, show: false, value: false });
      }
      setFieldValue({ fieldName: name, fieldValue: inputValue });

      //mobile number validations on input
      if (
        formattedResult.trim().length !== 10 &&
        formattedResult.trim().length > 0
      ) {
        setErrors({
          name: name,
          errorMessage: "Enter 10 digit mobile number.",
        });
        return;
      }
      if (
        value.target.value.replace(/-/g, "").trim() !== "" &&
        !fetchedUserDetails.Email
      ) {
        getUserDetails({ inputFieldName: name, inputFieldValue: inputValue });
      }
      if (userDetailsFetchField === "email") {
        setfetchedUserDetails((prevState) => ({
          ...prevState,
          MobilePhone: inputValue,
        }));
      }
    } else if (name === "email") {
      setFieldValue({ fieldName: name, fieldValue: inputValue });

      //email field validation on input
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(inputValue) && inputValue.trim().length > 0) {
        setErrors({
          name: name,
          errorMessage: "Enter a valid  email address.",
        });
        return;
      }
      if (inputValue.trim() === "" && inputValue.length !== 0) {
        setErrors({
          name: name,
          errorMessage: "Invalid entry!",
        });
        return;
      }
      if (!fetchedUserDetails.MobilePhone && inputValue.trim().length !== 0) {
        setTimeout(() => {
          getUserDetails({ inputFieldName: name, inputFieldValue: inputValue });
        }, 500);
      }
      if (userDetailsFetchField === "mobile") {
        setfetchedUserDetails((prevState) => ({
          ...prevState,
          Email: inputValue,
        }));
      }
    } else {
      setErrors({
        name: name,
        errorMessage: `Something went wrong.Please try entering ${name} again`,
      });
    }
  };
  const setErrors = ({ name, errorMessage }) => {
    setInputFields((prevInputFields) => ({
      ...prevInputFields,
      [name]: {
        ...prevInputFields[name],
        error: errorMessage,
      },
    }));
  };
  const isChecked = (value) => {
    return (
      fetchedUserDetails.Fieldssubscribed.find(
        (e) => e.type == selectedType
      )?.fields?.indexOf(value) >= 0
    );
  };
  const checkboxHandler = async (event, name) => {
    console.log("this", event.target, name);
    // console.log("field selected", event.target.checked, name);
    if (blockInputField) {
      displayGlobalError(
        "Fields can't be modified while the form submission is in process."
      );
      return;
    }
    let idx = null;
    fetchedUserDetails?.Fieldssubscribed?.forEach((field, index) => {
      if (name === field.type) {
        idx = index;
      }
    });
    //if the field is checked then it will add that particular field to the user details
    if (event.target.checked && idx === null) {
      // console.log("index not availble");
      setfetchedUserDetails((prevDetails) => ({
        ...prevDetails,
        Fieldssubscribed: [
          ...prevDetails.Fieldssubscribed,
          {
            type: selectedType,
            fields: [event.target.value],
            fieldNames: [event.target.name],
          },
        ],
      }));
    } else if (event.target.checked && idx !== null) {
      // console.log("index available", event.target.value, name);
      setfetchedUserDetails((prevDetails) => ({
        ...prevDetails,
        Fieldssubscribed: prevDetails.Fieldssubscribed.map((subscription) => {
          // console.log("subuuus", subscription);
          if (subscription.type === name) {
            return {
              type: subscription.type,
              fields: [...subscription.fields, event.target.value],
              fieldNames: [...subscription.fieldNames, event.target.name],
            };
          }
          return subscription;
        }),
      }));
    } else if (!event.target.checked && idx !== null) {
      // console.log("removing field");
      setfetchedUserDetails((prevDetails) => ({
        ...prevDetails,
        Fieldssubscribed: prevDetails.Fieldssubscribed.map((subscription) => {
          if (subscription.type === name) {
            return {
              type: subscription.type,
              fields: subscription.fields.filter(
                (name) => name !== event.target.value
              ),
              fieldNames: subscription.fieldNames.filter(
                (name) => name !== event.target.name
              ),
            };
          }

          return subscription;
        }),
      }));

      if (fetchedUserDetails.Fieldssubscribed[idx].fields.length === 1) {
        removePark({ field: fetchedUserDetails.Fieldssubscribed[idx] });
      }
    } else {
      displayGlobalError("Something went wrong!.Please try again.");
      setTimeout(() => {
        closeModal();
      }, 2000);
    }
  };
  const handleTypeChange = (event) => {
    if (blockInputField) {
      displayGlobalError(
        "Fields can't be modified while the form submission is in process."
      );
      return;
    }
    setSelectedType(event.target.value);
  };

  const getUserDetails = async ({ inputFieldName, inputFieldValue }) => {
    setUserDetailsFetchField(inputFieldName);
    let userDetailsApi =
      inputFieldName === "mobile"
        ? "api/park/notifyusersmobile?phone="
        : "api/park/notifyusersemail?email=";

    await smartParkService
      .get(userDetailsApi + inputFieldValue)
      .then((res, err) => {
        if (res.status === 200 && res.data.data) {
          inputFieldName === "mobile"
            ? setFetchedSecondaryFieldValue(res.data.data.Email)
            : setFetchedSecondaryFieldValue(res.data.data.MobilePhone);

          if (inputFieldName === "mobile" && res.data.data.UserNotifyID) {
            setConsentField({ ...consentField, show: false, value: true });
          }
          if (
            inputFieldName === "email" &&
            res.data.data.UserNotifyID &&
            res.data.data.MobilePhone
          ) {
            setFieldValue({
              fieldName: "mobile",
              fieldValue: res.data.data.MobilePhone,
            });
            setConsentField({ ...consentField, show: false, value: true });
          }

          if (
            inputFieldName === "mobile" &&
            res.data.data.UserNotifyID &&
            res.data.data.Email
          ) {
            setFieldValue({
              fieldName: "email",
              fieldValue: res.data.data.Email,
            });
            setConsentField({ ...consentField, show: false, value: true });
          }

          //for existing user with data in database
          const fields = [];
          //iterating the user subscribed fields with the fields available at the park
          for (const field of res.data.data.Fieldssubscribed) {
            console.log("field", field);
            if (field.fields.length > 0) {
              // Check if the field subscirbed by the user exists in current park
              if (facilitiesList[field.type]) {
                // If the subscribed field is available then push it into the list of fields.
                fields.push(field);
              } else {
                // Handle the case where there is no match
                // console.log(field,`No match found for type ${field.type}`);
              }
            }
          }

          setfetchedUserDetails((prevState) => ({
            ...prevState,
            UserNotifyID: res.data.data.UserNotifyID,
            MobilePhone: res.data.data.MobilePhone,
            Email: res.data.data.Email,
            Fieldssubscribed: fields,
          }));
        } else if (res.status === 200 && res.data.data === null) {
          if (inputFieldName === "mobile" && res.data.data === null) {
            // console.log("new user with mobile number");
            setConsentField({ ...consentField, show: true });
          }
          //if there is no available user data
          setfetchedUserDetails({
            UserNotifyID: null,
            MobilePhone: inputFieldName === "mobile" ? inputFieldValue : "",
            Email: inputFieldName === "email" ? inputFieldValue : "",
            Fieldssubscribed: [],
          });
        } else {
          renderToasts({
            message: "Something went wrong while fetching the user data.",
          });
        }
      });
  };

  const submitForm = async () => {
    // console.log("formstate", formState, fetchedUserDetails);
    if (formState === "submit") {
      await sendVerificationOtp();
    }
    if (formState === "NU-OTP") {
      await verifyEnteredOtp(otpField.fieldValue, "NU");
    }
    if (formState === "EU-OTP") {
      await verifyEnteredOtp(otpField.fieldValue, "EU");
    }
    if (formState === "eEU-OTP") {
      await verifyEnteredOtp(otpField.fieldValue, "eEU");
    }
    if (formState === "eNU-OTP") {
      await verifyEnteredOtp(otpField.fieldValue, "eNU");
    }
    if (formState === "DV-NU-MOTP") {
      await verifyEnteredOtp(otpField.fieldValue, "DV-M-NU");
    }
    if (formState === "DV-NU-EOTP") {
      await verifyEnteredOtp(otpField.fieldValue, "DV-E-NU");
    }
    if (formState === "DV-EU-MOTP") {
      await verifyEnteredOtp(otpField.fieldValue, "DV-M-EU");
    }
    if (formState === "DV-EU-EOTP") {
      await verifyEnteredOtp(otpField.fieldValue, "DV-E-EU");
    }
    if (formState === "NU-SAVE") {
      saveUserData("NU");
    }
    if (formState === "EU-SAVE") {
      saveUserData("EU");
    }
  };
  const sendVerificationOtp = async () => {
    if (
      fetchedUserDetails.MobilePhone === null &&
      fetchedUserDetails.Email === null
    ) {
      displayGlobalError(
        "Mobile/Email is required for subscribing to notifications."
      );
      return;
    }

    if (
      fetchedUserDetails.UserNotifyID === null &&
      fetchedUserDetails.Fieldssubscribed.length === 0
    ) {
      displayGlobalError("Please select the fields before submitting.");
      return;
    }

    if (!consentField.value && userDetailsFetchField === "mobile") {
      setConsentField({
        ...consentField,
        errorMessage: "Consent is required for notifications.",
      });
      return;
    }

    if (!consentField.value && consentField.show) {
      setConsentField({
        ...consentField,
        errorMessage: "Consent is required for notifications.",
      });
      return;
    }

    //block any updation to the fields once validation is passed
    setBlockInputField(true);
    const accessToken = GenerateEncryptedToken();

    // console.log("before", fetchedUserDetails);
    if (
      (userDetailsFetchField === "mobile" &&
        fetchedSecondaryFieldValue === fetchedUserDetails.Email) ||
      (userDetailsFetchField === "email" &&
        fetchedSecondaryFieldValue === fetchedUserDetails.MobilePhone) ||
      (userDetailsFetchField === "email" &&
        fetchedUserDetails.MobilePhone === "") ||
      (userDetailsFetchField === "mobile" && fetchedUserDetails.Email === "")
    ) {
      // console.log("mobile or email", fetchedUserDetails);
      if (fetchedUserDetails.UserNotifyID === null) {
        const verificationApi =
          userDetailsFetchField === "email"
            ? `api/park/verifyuseremail/${fetchedUserDetails.Email}`
            : `api/park/verifyusermobile/${fetchedUserDetails.MobilePhone.replace(
                /-/g,
                ""
              )}`;
        smartParkService.get(verificationApi).then(async (res, err) => {
          if (res.status === 200) {
            // renderToasts({ message: res.data.message });
            renderToasts({ message: "Activation code sent successfully!" });
            setFormState(
              userDetailsFetchField === "email" ? "eNU-OTP" : "NU-OTP"
            );
            setOtpField({
              ...otpField,
              show: true,
              fieldLabel:
                userDetailsFetchField === "email"
                  ? "Enter activation code received on your email address."
                  : "Enter activation code received on your mobile phone.",
            });
          } else {
            renderToasts({ message: "Something went wrong.Please try again." });
            // console.log("error occured while sending otp");
          }
          // console.log("mobile", res);
        });
      } else {
        // console.log("otp else");
        let data;
        if (userDetailsFetchField === "email") {
          data = {
            type: 0, //0 for email 1 for sms
            email: fetchedUserDetails.Email,
            mobile:
              fetchedSecondaryFieldValue === fetchedUserDetails.MobilePhone
                ? ""
                : fetchedUserDetails.MobilePhone,
          };
        } else {
          data = {
            type: 1, //0 for email 1 for sms
            mobile: fetchedUserDetails.MobilePhone,
            email:
              fetchedSecondaryFieldValue === fetchedUserDetails.Email
                ? ""
                : fetchedUserDetails.Email,
          };
        }
        smartParkService
          .post("api/park/update/confirmation", data, {
            headers: {
              "x-access-token": accessToken,
            },
          })
          .then((res) => {
            if (res.data.status === 200) {
              // renderToasts({ message: res.data.message });
              renderToasts({ message: "Update code sent successfully!" });
              setFormState(
                userDetailsFetchField === "mobile" ? "EU-OTP" : "eEU-OTP"
              );
              setOtpField({
                ...otpField,
                show: true,
                fieldLabel:
                  userDetailsFetchField === "mobile"
                    ? "Enter update code received on your mobile."
                    : "Enter update code received on your email",
              });
            } else {
              renderToasts({ message: "Something went wrong!" });
            }
          });
      }
    } else {
      // console.log("mobile and email");
      doubleOtpVerification({ verificationField: "mobile" });
    }
  };
  const verifyEnteredOtp = async (otp, userstatus) => {
    const responseToken = GenerateEncryptedToken();
    if (userstatus === "NU" || userstatus === "eNU") {
      let api =
        userDetailsFetchField === "mobile"
          ? `api/park/verifysmsotp?mobile=${fetchedUserDetails.MobilePhone.replace(
              /-/g,
              ""
            )}&otp=${otp}`
          : `api/park/verifyemailotp?email=${fetchedUserDetails.Email}&otp=${otp}`;
      await smartParkService.get(api).then((res) => {
        if (res.data.status === 200) {
          // console.log("thisis");
          // renderToasts({ message: res.data.message });
          renderToasts({ message: "Activation code verified." });
          setFormState(userstatus === "DV-NU" ? "DV-NU-EOTP" : "NU-SAVE");
          hideOtpField();
        } else if (res.data.status === 500) {
          setOtpField({
            ...otpField,
            fieldValue: otp,
            error: res.data.message,
          });
        } else {
          setOtpField({
            ...otpField,
            error: "Activation code could not be verified. Please try again!",
          });
        }
        // console.log("otp verification", otpField.fieldValue, res);
      });
    } else if (userstatus === "EU" || userstatus === "eEU") {
      let data;
      if (userstatus === "EU") {
        data = {
          type: 0, // 0 for sms 1 for email
          mobile: fetchedUserDetails.MobilePhone,
          otp: otp,
        };
      } else if (userstatus === "eEU") {
        data = {
          type: 1, // 0 for sms 1 for email
          email: fetchedUserDetails.Email,
          mobile: null,
          otp: otp,
        };
      } else {
        displayGlobalError("Something went wrong. Please try again.");
        setTimeout(() => {
          closeModal();
        }, 2000);
      }

      smartParkService
        .post("api/park/update/verify", data, {
          headers: {
            "x-access-token": responseToken,
          },
        })
        .then((res) => {
          if (res.data.status == 200) {
            // renderToasts({ message: res.data.message });
            renderToasts({ message: "Updation code verified successfully." });
            setFormState("EU-SAVE");
            hideOtpField();
          } else if (res.data.status === 500) {
            setOtpField({
              ...otpField,
              fieldValue: otp,
              error: res.data.message,
            });
          } else {
            // console.log("else");
            setOtpField({
              ...otpField,
              error: "Updation code could not be verified. Please try again!",
            });
          }
        });
    } else if (userstatus === "DV-M-NU" || userstatus === "DV-E-NU") {
      // console.log("verify otp twice", userstatus);
      let api =
        userstatus === "DV-M-NU"
          ? `api/park/verifysmsotp?mobile=${fetchedUserDetails.MobilePhone.replace(
              /-/g,
              ""
            )}&otp=${otp}`
          : `api/park/verifyemailotp?email=${fetchedUserDetails.Email}&otp=${otp}`;
      await smartParkService.get(api).then((res) => {
        if (res.data.status === 200) {
          // console.log("ressave", userstatus);
          hideOtpField();
          renderToasts({ message: "Activation code verified." });
          // setFormState(userstatus === "DV-M-NU" ? "DV-NU-EOTP" : "NU-SAVE");
          if (userstatus === "DV-M-NU") {
            setFormState("DV-NU-EOTP");
            doubleOtpVerification({ verificationField: "email" });
            return;
          } else {
            setFormState("NU-SAVE");
          }
        } else if (res.data.status === 500) {
          setOtpField({
            ...otpField,
            fieldValue: otp,
            error: res.data.message,
          });
        } else {
          setOtpField({
            ...otpField,
            error: "Activation code could not be verified. Please try again!",
          });
        }
        // console.log("otp in ", otpField.fieldValue, res);
      });
    } else if (userstatus === "DV-M-EU" || userstatus === "DV-E-EU") {
      // console.log("userstatus verification", userstatus);
      let data;
      if (userstatus === "DV-M-EU") {
        data = {
          type: 0, // 0 for sms 1 for email
          mobile: fetchedUserDetails.MobilePhone,
          otp: otp,
        };
      } else if (userstatus === "DV-E-EU") {
        data = {
          type: 1, // 0 for sms 1 for email
          email: fetchedUserDetails.Email,
          mobile: null,
          otp: otp,
        };
      } else {
        displayGlobalError("Something went wrong. Please try again.");
        setTimeout(() => {
          closeModal();
        }, 2000);
      }

      smartParkService
        .post("api/park/update/verify", data, {
          headers: {
            "x-access-token": "citizen",
          },
        })
        .then((res) => {
          if (res.data.status == 200) {
            // renderToasts({ message: res.data.message });
            renderToasts({ message: "Updation code verified." });
            hideOtpField();
            if (userstatus === "DV-M-EU") {
              // console.log("entered here");
              setFormState("DV-E-EU");
              doubleOtpVerification({ verificationField: "email" });
              return;
            } else {
              // console.log("reached here FOR SAVING");
              setFormState("EU-SAVE");
            }
          } else if (res.data.status === 500) {
            setOtpField({
              ...otpField,
              fieldValue: otp,
              error: res.data.message,
            });
          } else {
            // console.log("else");
            setOtpField({
              ...otpField,
              error: "Updation code could not be verified. Please try again!",
            });
          }
        });
    }
  };
  const doubleOtpVerification = async ({ verificationField }) => {
    if (fetchedUserDetails.UserNotifyID === null) {
      // console.log("doubleverification function", verificationField);
      const verificationApi =
        verificationField === "mobile"
          ? `api/park/verifyusermobile/${fetchedUserDetails.MobilePhone.replace(
              /-/g,
              ""
            )}`
          : `api/park/verifyuseremail/${fetchedUserDetails.Email}`;

      await smartParkService.get(verificationApi).then(async (res, err) => {
        if (res.status === 200) {
          renderToasts({
            message:
              verificationField === "email"
                ? "Activation code sent successfully on the provided email address."
                : "Activation code sent successfully on the provided mobile number.",
          });
          setFormState(
            verificationField === "mobile" ? "DV-NU-MOTP" : "DV-NU-EOTP"
          );
          setOtpField({
            ...otpField,
            fieldValue: "",
            show: true,
            fieldLabel:
              verificationField === "email"
                ? "Enter the activation code received on your email address."
                : "Enter the activation code received on your mobile phone.",
          });
        } else {
          renderToasts({
            message:
              "Error occured while sending activation code.Please try again.",
          });
        }
      });
    } else {
      // console.log("double verification existing user", verificationField);
      let data;
      if (verificationField === "mobile") {
        data = {
          type: 1, //0 for email 1 for sms
          mobile: fetchedUserDetails.MobilePhone,
        };
      } else {
        data = {
          type: 0, //0 for email 1 for sms
          email: fetchedUserDetails.Email,
        };
      }
      smartParkService
        .post("api/park/update/confirmation", data, {
          headers: {
            "x-access-token": "citizen",
          },
        })
        .then((res) => {
          if (res.data.status == 200) {
            setFormState(
              verificationField === "mobile" ? "DV-EU-MOTP" : "DV-EU-EOTP"
            );
            setOtpField({
              ...otpField,
              fieldValue: "",
              show: true,
              fieldLabel:
                verificationField === "mobile"
                  ? "Enter update code received on your mobile."
                  : "Enter update code received on your email",
            });
          } else {
            renderToasts({ message: "Something went wrong.Please try again." });
          }
        });

      // console.log("data", data);
    }
  };
  const saveUserData = async (userstatus) => {
    // console.log("here", userstatus);
    const accessToken = GenerateEncryptedToken();
    const saveUserApi =
      userstatus === "NU"
        ? "/api/park/notifyusers"
        : "api/park/update/notification";

    let data;
    if (userstatus === "NU") {
      data = {
        MobilePhone: fetchedUserDetails.MobilePhone.replace(/-/g, ""),
        Email: fetchedUserDetails.Email,
        Fieldssubscribed: fetchedUserDetails.Fieldssubscribed,
      };
    } else {
      data = fetchedUserDetails;
    }
    await smartParkService
      .post(saveUserApi, data, {
        headers: {
          "x-access-token": accessToken,
        },
      })
      .then((res) => {
        if (res.data.status == 200) {
          // renderToasts({ message: res.data.message });
          renderToasts({
            message:
              userstatus === "NU"
                ? "Subscription successful."
                : "Successfully updated.",
          });
          closeModal();
        }
      });
  };
  useEffect(() => {
    if (parkArray) {
      const list = {};
      setSelectedType(parkArray[0].short_name);
      parkArray.forEach((park) => {
        list[park.short_name] = {
          name: park.park_name,
          value: park.short_name,
          fields: park.field_data,
        };
      });
      setFacilitiesList(list);
    }
  }, [parkArray]);
  // useEffect(async () => {
  //   // Set the initial value and cursor position at the beginning after the component mounts
  //   if (inputRef.current) {
  //     inputRef.current.setSelectionRange(0, 0);
  //   }
  //   const list = {};
  //   const mcpFields = [];
  //   await smartParkService
  //     .get("/api/citizen/fielddata2")
  //     .then(async (res, err) => {
  //       if (res.data.status == 200) {
  //         setSelectedType("MCP");
  //         list["MCP"] = {
  //           name: "Morrisville Community Park",
  //           value: "MCP",
  //           fields: res.data.data,
  //         };
  //       }
  //     })
  //     .then(async () => {
  //       await smartParkService
  //         .get("/api/citizen/fielddata3")
  //         .then(async (res, err) => {
  //           if (res.data.status == 200) {
  //             list["CFDP"] = {
  //               name: "Cedar Fork District Park",
  //               value: "CFDP",
  //               fields: res.data.data,
  //             };
  //           }
  //         });
  //     })
  //     .then(async () => {
  //       await smartParkService
  //         .get("/api/citizen/fielddata4")
  //         .then(async (res, err) => {
  //           if (res.data.status == 200) {
  //             list["SP"] = {
  //               name: "Shiloh Park",
  //               value: "SP",
  //               fields: res.data.data,
  //             };
  //           }
  //         });
  //     })
  //     .then(async () => {
  //       await smartParkService
  //         .get("/api/citizen/fielddata5")
  //         .then(async (res, err) => {
  //           if (res.data.status == 200) {
  //             list["CCNP"] = {
  //               name: "Crabtree Creek Nature Park",
  //               value: "CCNP",
  //               fields: res.data.data,
  //             };
  //           }
  //         });
  //     })
  //     .then(async () => {
  //       await smartParkService.get("/api/courts").then(async (res, err) => {
  //         if (res.data.status == 200) {
  //           // console.log("thirs", res);
  //           list["MAFC"] = {
  //             name: "Morrisville Aquatics & Fitness Center",
  //             value: "MAFC",
  //             fields: res.data.data,
  //           };
  //         }
  //       });
  //     })
  //     .then(async () => {
  //       await smartParkService
  //         .get("/api/churchstreetcourts")
  //         .then(async (res, err) => {
  //           if (res.data.status == 200) {
  //             // console.log("forth", res);
  //             list["CSPTC"] = {
  //               name: "Church Street Park",
  //               value: "CSPTC",
  //               fields: res.data.data,
  //             };
  //           }
  //         });
  //     })
  //     .then(async () => {
  //       await smartParkService.get("api/mcpcourts").then(async (res, err) => {
  //         if (res.data.status == 200) {
  //           // console.log("this responses", res);
  //           res.data.data.forEach((data) => {
  //             list["MCP"].fields.push(data);
  //           });
  //         }
  //       });
  //     });

  //   setFacilitiesList(list);
  //   // setTimeout(() => {
  //   //   console.log("list", facilitiesList);
  //   // }, 10000);
  //   // smartParkService.get("api/mcpcourts").then(async (res, err) => {
  //   //   if (res.data.status == 200) {
  //   //     await setmcpcourtdata(res.data.data);
  //   //   }
  //   // });

  //   // await smartParkService
  //   //   .get("/api/events/wake-demo/wf/park")
  //   //   .then(async (res, err) => {
  //   //     if (res.data.status == 200) {
  //   //       const list = {};
  //   //       await res.data.data.forEach((data, idx) => {
  //   //         if (idx === 0) {
  //   //           setSelectedType(data.park_name);
  //   //         }
  //   //         list[data.park_name] = {
  //   //           name: data.park_name,
  //   //           value: data.park_name,
  //   //           fields: data.field_data,
  //   //         };
  //   //       });
  //   //       setFacilitiesList(list);
  //   //     }
  //   //   });
  // }, []); // Empty dependency array ensures this effect runs only once on mount

  return (
    <div>
      <ToastContainer />
      <ModalDialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={modalStatus}
        aria-labelledby="field-model"
      >
        <DialogTitle id="field-model-title">
          <strong> Notify Me </strong>
          <div style={{ color: "red" }}>{globalError}</div>
        </DialogTitle>
        <DialogContent className={classes.modalHeight}>
          <DialogContentText>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <InputMask
                  mask="999-999-9999"
                  fullWidth
                  value={inputFields.mobile.value}
                  onChange={(e) => {
                    inputHandler({ name: "mobile", value: e });
                  }}
                  maskChar=" "
                >
                  {() => (
                    <TextField
                      variant="outlined"
                      size="small"
                      fullWidth
                      id="phone"
                      label="Mobile Number ( Optional )"
                      inputRef={inputRef}
                    />
                  )}
                </InputMask>
                <div style={{ color: "red" }}>{inputFields.mobile.error}</div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  variant="outlined"
                  size="small"
                  id="emailadresss"
                  name="emailadresss"
                  label="Email Address"
                  fullWidth
                  value={inputFields.email.value}
                  onChange={(e) => {
                    inputHandler({ name: "email", value: e });
                  }}
                />
                <div style={{ color: "red" }}>{inputFields.email.error}</div>
              </Grid>

              <Grid item xs={12} sm={12}>
                <FormControl
                  size="small"
                  variant="outlined"
                  className={classes.w100p}
                >
                  <InputLabel id="parkSelect">Select Park</InputLabel>
                  <Select
                    labelId="parkSelect"
                    fullWidth
                    value={selectedType}
                    label="Facility Name"
                    onChange={handleTypeChange}
                  >
                    {Object.values(facilitiesList).map((e) => {
                      return (
                        <MenuItem key={e.value} value={e.value}>
                          {e.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={12}>
                <FormControl
                  component="fieldset"
                  className={classes.formControl}
                >
                  <FormLabel>
                    <strong>Choose fields/Courts</strong>
                  </FormLabel>
                  {Object.values(facilitiesList).map((value) => {
                    if (value.value === selectedType) {
                      return (
                        <FormGroup row>
                          {value.value === selectedType
                            ? value.fields.map((field) => {
                                return (
                                  <FormControlLabel
                                    key={field.field_id}
                                    control={
                                      <Checkbox
                                        color="primary"
                                        checked={isChecked(field.field_id)}
                                        value={field.field_id}
                                        onChange={(e) => {
                                          checkboxHandler(e, selectedType);
                                        }}
                                        name={field.field_name}
                                      />
                                    }
                                    label={field.field_name}
                                  />
                                );
                              })
                            : ""}
                        </FormGroup>
                      );
                    }
                  })}
                </FormControl>
              </Grid>
              <p className={notify.subcribed}>
                <strong>Subscribed Summary</strong>
              </p>
              <Grid item xs={12} sm={12}>
                {fetchedUserDetails?.Fieldssubscribed?.map((field) => {
                  // console.log("name", field);
                  return (
                    <>
                      <ul
                        className={notify.subcribedol}
                        style={{ listStyle: "none" }}
                      >
                        <li className={notify.subcribedli}>
                          <Chip
                            label={facilitiesList[field.type].name}
                            onDelete={() => {
                              removePark({ field: field });
                            }}
                          />
                        </li>
                      </ul>
                      <ul>
                        {field.fieldNames.map((item, idx) => (
                          <li key={item}>
                            <Chip
                              label={item}
                              id={item}
                              key={item}
                              onDelete={() =>
                                removeField({
                                  index: idx,
                                  id: field.fields[idx],
                                  fieldName: field.fieldNames[idx],
                                  park: field,
                                })
                              }
                            />
                          </li>
                        ))}
                      </ul>
                    </>
                  );
                })}
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className="checknotifynumber">
                  <>
                    <div style={{ color: "red" }}>
                      {consentField.errorMessage}
                    </div>
                    {consentField.show ? (
                      <FormControlLabel
                        key={consentField.label}
                        control={
                          <Checkbox
                            color="primary"
                            checked={consentField.value}
                            value={consentField.value}
                            onChange={consentBoxHandler}
                            name={consentField.name}
                          />
                        }
                        label={consentField.label}
                      />
                    ) : (
                      ""
                    )}
                  </>
                  <>
                    {!consentField.show && consentField.value ? (
                      <div>
                        You have already provided the consent to receive SMS
                        notifications.
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                </div>
              </Grid>
              {/* form footer */}
              {otpField.show ? (
                <>
                  <Grid item xs={12} sm={12}>
                    <span style={{ color: "red" }}>{otpField.fieldLabel}</span>
                    <TextField
                      variant="outlined"
                      size="small"
                      id="Registrationcode"
                      name="Registrationcode"
                      label="Verification code"
                      fullWidth
                      className="mt-2"
                      value={otpField.fieldValue}
                      onChange={otpInputHandler}
                    />
                    <div style={{ color: "red" }}>{otpField.error}</div>
                  </Grid>
                </>
              ) : (
                ""
              )}
              <>
                <Button
                  color="primary"
                  variant="contained"
                  disabled={false}
                  className={classes.btnRound}
                  onClick={submitForm}
                >
                  {formState === "submit"
                    ? "Submit"
                    : formState === "NU-SAVE" || formState === "EU-SAVE"
                    ? "Save"
                    : "Verify"}
                </Button>
                <Button
                  color="default"
                  round
                  className={classes.btnRound}
                  onClick={closeModal}
                >
                  Cancel
                </Button>
              </>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </ModalDialog>
    </div>
  );
}
